/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import sliceUrl from "@utils/sliceHistoryHash";
import { translations } from "@utils/translations";
import removeParamsFormHash from "@utils/removeParamasFromHash";
import FilterItem from "./FilterItem";
import { setFilter } from "../store/actions";
import { IconCross } from "./icons";
import styles from "../../../styles/components/selection.module.scss";

const SearchSelection = ({ data, params = {}, resetHandler }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
  const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";
  const handleClick = useCallback((value, active) => {
    dispatch(setFilter(removeParamsFormHash(history.location.hash.replace("#", ""), value), true));
  }, []);

    const handleKeyDown = (event, value, active) => {
        if (!["Enter", "Space"].includes(event.code)) {
            return;
        }

        event.preventDefault();

        handleClick(value, active);
    };
  let selectedItems = {};
  let choicesItems = [];
  Object.keys(params).forEach((item) => {
    if (params[item].choices) {
      choicesItems.push(...params[item].choices);
    }
    params[item].selected.forEach((el) => {
      selectedItems[el] = el;
    }, {});
  });

  if (!data.length) return null;

  // eslint-disable-next-line no-unused-vars
  const translate = (s) => translations[lang][s] || s;

  const onClick = () => {
      const hash = history.location.hash.replace("#", "");
      const page = hash.indexOf("page");
      const uri = `${sliceUrl(page, hash)}`;
      dispatch(setFilter(uri, true));
      return history.push({
          pathname: appSettings.searchSlug,
          hash: `#${uri}`,
      });
  };

  return (
        <>
            <div className={styles.text}>
                {translate("selection")}
            </div>
            {choicesItems.filter(({ value }) => selectedItems[value]).map(({ value, label }, index) => (
                <FilterItem
                    className={`${styles.item}`}
                    name={label}
                    value={value}
                    key={index}
                    isCross
                    active
                    tabIndex={0}
                    handleKeyDown={handleKeyDown}
                    handleClick={handleClick}
                />
            ))}
            <div
                className={`${styles.item} ${styles.reset}`}
                tabIndex={0}
                onClick={() => onClick}
                onKeyDown={(e) => {
                    if (["Enter", "Space"].includes(e.key)) {
                        e.preventDefault();
                        onClick();
                    }
                }}
            >
                <label className={styles.label}>
                    {translate("selection_clear")}
                </label>
                <div className={styles.option}>
                    <span><IconCross/></span>
                </div>
            </div>
        </>
  );
};

export default SearchSelection;
